import { PlusOutlined } from '@ant-design/icons'
import { Card, Flex } from 'antd'
import { useTheme } from 'antd-style'

import { Text } from 'src/components'

import { GroupNodeProps } from '../types'

import { useStyles } from './styles'

export const GroupNode = ({
  node,
  depth,
  length,
  idx = 0,
  onAddChild
}: GroupNodeProps) => {
  const theme = useTheme()

  const colorMap: Record<string, string> = {
    '0': theme.complimentary.complimentary1,
    '1': theme.complimentary.complimentary2,
    '2': theme.complimentary.complimentary3,
    '3': theme.complimentary.complimentary4,
    default: theme.colorPrimary
  }

  const cardStyles = (color: string) => ({
    backgroundColor: color,
    color: theme.colorWhite
  })

  const countStyles = (color: string) => ({
    border: `2px solid ${color}`,
    color: color
  })

  const isRoot = node?.parentId === null
  const isLabel = depth === 1

  const getColor = () => {
    return colorMap[idx] || colorMap['default']
  }

  const colorValue = getColor()

  const { styles } = useStyles({
    isRoot,
    isLabel,
    color: colorValue
  })

  return (
    <Flex className={styles.flex} align="center">
      <Card
        className={styles.card}
        styles={{
          body: {
            height: 82
          }
        }}
        style={{
          ...(isLabel && cardStyles(colorValue))
        }}
      >
        <Flex
          vertical
          align="center"
          justify="center"
          className={styles.content}
        >
          <Text size="md">{node?.name}</Text>

          {(isRoot || isLabel) && !!length && (
            <Text
              size="xl"
              className={styles.countCircle}
              style={{
                ...(isLabel && countStyles(colorValue))
              }}
            >
              {length}
            </Text>
          )}
          {!length && (
            <PlusOutlined
              onClick={(e) => {
                e.stopPropagation()
                onAddChild(String(node?.id))
              }}
              className={styles.countCircle}
              style={{
                color: theme.colorPrimary
              }}
            />
          )}
        </Flex>
      </Card>
    </Flex>
  )
}
